import { withCompInfo } from '../../core/withCompInfo'
import _ from 'lodash'
import { VideoPlayerDefinition, VideoPlayerProps, VideoPlayerData } from './types'

export const props = withCompInfo<VideoPlayerProps, VideoPlayerDefinition>(
	['compData', 'compProps', 'isMobileView', 'compLayout'],
	({ compData, compProps, isMobileView, compLayout }) => {
		return {
			src: getVideoUrl(compData) || '',
			loop: compProps.loop,
			controls: compProps.controlsVisibility === 'hover',
			showTitle: compProps.showVideoTitle,
			playableConfig: {
				title: compData.videoTitle || '',
				description: compData.description || '',
				poster: compData.videoRef?.posterImageRef,
			},
			muted: compProps.autoplay,
			autoplay: compProps.autoplay,
			isMobileView,
			containerDimensions: { width: `${compLayout.width}px`, height: `${compLayout.height}px` },

			currentTime: 0,
			duration: compData.videoRef?.duration || 0,
			isPlaying: false,
			volume: compProps.autoplay ? 0 : 100,
			isMuted: compProps.autoplay,
		}
	}
)

const getVideoUrl = (compData: VideoPlayerData) => {
	const { videoUrl } = compData
	if (videoUrl) {
		return videoUrl
	}

	const qualities = _.get(compData, 'videoRef.qualities')

	if (!qualities || !qualities.length) {
		return
	}

	const { url } = _.maxBy(qualities, 'width') as typeof qualities[0]

	return `https://video.wixstatic.com/${url}` // TODO staticVideoUrl
}
